/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_File_OpenInputs */

const cs_chat_file_open = /** @type {(inputs: Chat_File_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít`)
};

const en_chat_file_open = /** @type {(inputs: Chat_File_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Chat_File_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_file_open = /** @type {((inputs?: Chat_File_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_File_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_file_open(inputs)
	return cs_chat_file_open(inputs)
});